import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router';
import OrderKits from '~/components/OrderKits/OrderKits';
import { kitRequestsQueryOptions } from '~/services/practitioner/kitRequestsQueryOptions';

function OrderKitsLayout() {
  const matches = useMatches();

  // Check if we have any child routes active
  const hasChildRoute = matches.some(
    match =>
      match.routeId !== '/_authed/order-kits' &&
      match.routeId.startsWith('/_authed/order-kits/'),
  );

  // If we have a child route active, render the outlet
  if (hasChildRoute) {
    return <Outlet />;
  }

  // Otherwise render the main OrderKits component
  return <OrderKits />;
}

export const Route = createFileRoute('/_authed/order-kits')({
  loader: async ({ context }) => {
    if (context.isAuthenticated) {
      await context.queryClient.ensureQueryData(kitRequestsQueryOptions(true));
    }
  },
  component: OrderKitsLayout,
});
